import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AppSharedFacade, NodeSharedFacade, TrainingSharedFacade } from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-quiz-start',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './quiz-start.component.html',
    styleUrls: ['./quiz-start.component.scss'],
    standalone: false
})
export class QuizStartComponent implements OnInit {

  public constructor(public trainingSharedFacade: TrainingSharedFacade,
                     public appSharedFacade: AppSharedFacade,
                     public nodeSharedFacade: NodeSharedFacade) {
  }

  public ngOnInit() {
    this.trainingSharedFacade.requestReset();
    this.trainingSharedFacade.requestTrainingNodesByCurrentSubject();
  }

  public toggleExpanded(item: { expanded: boolean},
                        event: Event) {
    event.stopPropagation();
    item.expanded = !item.expanded;
  }

  public isChecked(item: { nodeIds: string[]},
                         selectedSlides: Set<string>): boolean {
    return item.nodeIds.every(id => selectedSlides.has(id));
  }

  public isIndeterminate(item: { nodeIds: string[]},
                         selectedSlides: Set<string>): boolean {
    return item.nodeIds.some(id => selectedSlides.has(id));
  }
}
